import { useState } from 'react';
import { Link, useMatch, useNavigate } from 'react-router-dom';
import { ReportProblemModal } from './ReportProblemModal';
import { useAuthStore } from '../stores/platformAuthStore';
import { theme } from '../theme';

const styles = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '12px 24px',
    background: theme.bgPanel,
    borderBottom: `1px solid ${theme.border}`,
  } as const,
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: "'Pixelify', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    color: theme.accent,
    textDecoration: 'none',
  } as const,
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
  } as const,
  link: {
    color: theme.textSecondary,
    textDecoration: 'none',
    fontSize: '14px',
  } as const,
  btn: {
    padding: '6px 16px',
    borderRadius: theme.radiusMd,
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    background: theme.accent,
    color: theme.accentText,
  } as const,
  btnOutline: {
    padding: '6px 16px',
    borderRadius: theme.radiusMd,
    border: `1px solid ${theme.accent}`,
    cursor: 'pointer',
    fontSize: '14px',
    background: 'transparent',
    color: theme.accent,
  } as const,
};

export function Navbar() {
  const { user, token, logout } = useAuthStore();
  const navigate = useNavigate();
  const [reporting, setReporting] = useState(false);
  const projectPage = useMatch('/projects/:id/*');

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logo}>
        <img src={`${import.meta.env.BASE_URL}lune.svg`} alt="" width={20} height={20} />
        Lune
      </Link>

      <div style={styles.links}>
        <Link to="/guide" style={styles.link}>
          Guide
        </Link>
        <Link to="/known-issues" style={styles.link}>
          Known issues
        </Link>
        {token ? (
          <>
            <Link to="/dashboard" style={styles.link}>
              Dashboard
            </Link>
            <Link to="/account" style={styles.link}>
              Account
            </Link>
            {user?.role === 'admin' && (
              <Link to="/admin" style={styles.link}>
                Admin
              </Link>
            )}
            <button
              style={{ ...styles.link, background: 'none', border: 'none', cursor: 'pointer' }}
              onClick={() => setReporting(true)}
            >
              Report a problem
            </button>
            <span style={{ color: theme.textMuted, fontSize: '14px' }}>
              {user?.username || user?.email}
            </span>
            <button
              style={styles.btnOutline}
              onClick={() => {
                logout();
                navigate('/');
              }}
            >
              Log Out
            </button>
          </>
        ) : (
          <>
            <Link to="/login" style={styles.link}>
              Log In
            </Link>
            <button style={styles.btn} onClick={() => navigate('/signup')}>
              Sign Up
            </button>
          </>
        )}
      </div>
      {reporting && (
        <ReportProblemModal
          projectId={projectPage?.params.id}
          onClose={() => setReporting(false)}
        />
      )}
    </nav>
  );
}
